import React, { Component } from 'react';
import RequestView from './RequestView';
import styles from '../scss/Download.scss';

export class RequestPreview extends Component {

    state = {

        geoDatasets: [],
        allSites: [],
        geoDatasetsSelected: {},
        profileDatasets: [],
        profileDatasetsSelected: {},

        geoDatasetsPayload: "",
        profileDatasetsPayload: {},

        profileDatasetsBySites: [],
        geoDatasetsBySites: [],

        contactInfo: {}
    }


    componentDidMount() {
        if (this.props.onPayloadReady) {
            this.props.onPayloadReady(null);
        }
        this.restore();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    restore = () => {
        const geoDatasetsString = localStorage.getItem("geoDatasets");
        let geoDatasets = [];
        if (geoDatasetsString) {
            geoDatasets = JSON.parse(geoDatasetsString);
        }
        const allSitesString = localStorage.getItem("allSites");
        let allSites = [];
        if (allSitesString) {
            allSites = JSON.parse(allSitesString);
        }
        const geoDatasetsSelectedString = localStorage.getItem("geoDatasetsSelected");
        let geoDatasetsSelected = {};
        if (geoDatasetsSelectedString) {
            geoDatasetsSelected = JSON.parse(geoDatasetsSelectedString);
        }

        const profileDatasetsString = localStorage.getItem("profileDatasets");
        let profileDatasets = [];
        if (profileDatasetsString) {
            profileDatasets = JSON.parse(profileDatasetsString);
        }
        const profileDatasetsSelectedString = localStorage.getItem("profileDatasetsSelected");
        let profileDatasetsSelected = {};
        if (profileDatasetsSelectedString) {
            profileDatasetsSelected = JSON.parse(profileDatasetsSelectedString);
        }

        // contact info
        let contactInfo = {};
        const contactInfoString = localStorage.getItem("contactInfo");
        if (contactInfoString) {
            contactInfo = JSON.parse(contactInfoString);
        }

        this.setState({
            geoDatasets: geoDatasets,
            allSites: allSites,
            geoDatasetsSelected: geoDatasetsSelected,
            profileDatasets: profileDatasets,
            profileDatasetsSelected: profileDatasetsSelected,
            contactInfo: contactInfo
        }, () => {
            this.preparePayloadData();
        });
    }

    preparePayloadData = () => {
        // Geospatial Datasets
        const geoDatasetsIds = [];
        Object.keys(this.state.geoDatasetsSelected).forEach(key => {
            const ids = this.state.geoDatasetsSelected[key];
            ids.forEach(id => geoDatasetsIds.push(parseInt(id)));
        });

        // Profile Datasets
        const profileDatasetsPayload = {};
        Object.keys(this.state.profileDatasetsSelected).forEach(key => {
            const site = this.state.profileDatasets.find(s => s.name === key);
            const selectedIds = this.state.profileDatasetsSelected[key];

            // Get unique surveys
            const surveyIds = [...new Set(selectedIds.map((id) => {
                return id.split("_")[1];
            }))];

            const surveys = {};
            surveyIds.forEach((surveyId) => {
                const tracnsectIds = [];
                selectedIds.forEach((selectedId) => {
                    const parts = selectedId.split("_");
                    if (parseInt(parts[0]) === parseInt(site.id) && parseInt(parts[1]) === parseInt(surveyId)) {
                        tracnsectIds.push(parseInt(parts[2]));
                    }
                });
                surveys[surveyId.toString()] = tracnsectIds;
            });
            profileDatasetsPayload[site.id.toString()] = surveys;
        });

        this.setState({
            geoDatasetsPayload: geoDatasetsIds.join(","),
            profileDatasetsPayload: profileDatasetsPayload
        }, () => {
            this.generatePreviewData();
        });
    }

    generatePreviewData = () => {
        // Geospatial Datasets
        const geoDatasetsBySites = [];

        if (this.state.geoDatasetsPayload) {
            this.state.geoDatasetsPayload.split(",").forEach((id) => {
                const geoDataset = this.state.geoDatasets.find(g => g.id === parseInt(id));
                const site = this.state.allSites.find(s => s.name === geoDataset.siteName);

                let geoDatasetsBySite = geoDatasetsBySites.find(g => g.site.name === geoDataset.siteName);
                if (!geoDatasetsBySite) {
                    geoDatasetsBySite = {
                        // site: site,
                        site: { id: site.id, name: site.name, description: site.description },
                        surveys: []
                    };
                    geoDatasetsBySites.push(geoDatasetsBySite);
                }

                let survey = geoDatasetsBySite.surveys.find(s => s.name === geoDataset.groupName);
                if (!survey) {
                    survey = {
                        name: geoDataset.groupName,
                        layers: []
                    }
                    geoDatasetsBySite.surveys.push(survey);
                }

                survey.layers.push({ id: geoDataset.id, layerName: geoDataset.layerName, groupName: geoDataset.groupName });
            });
        }


        // Profile Datasets
        const profileDatasetsBySites = [];
        Object.keys(this.state.profileDatasetsPayload).forEach(siteId => {
            const site = this.state.profileDatasets.find(s => s.id === parseInt(siteId));
            const surveysInPayload = this.state.profileDatasetsPayload[siteId];

            const surveys = [];
            Object.keys(surveysInPayload).forEach(surveyId => {
                const survey = site.surveys.find(s => s.id === parseInt(surveyId));
                const transectsInPayload = surveysInPayload[surveyId.toString()];
                const transectNames = transectsInPayload.map((transectId) => {
                    return survey.transects.find(t => t.id === transectId).name;
                });

                surveys.push({
                    name: survey.name,
                    transects: transectNames.sort().join(", ")
                });
            });
            profileDatasetsBySites.push({
                // site: site,
                site: { id: site.id, name: site.name, description: site.description },
                surveys: surveys
            });
        });


        this.setState({
            geoDatasetsBySites: geoDatasetsBySites.sort((a, b) => a.site.name.localeCompare(b.site.name)),
            profileDatasetsBySites: profileDatasetsBySites.sort((a, b) => a.site.name.localeCompare(b.site.name))
        }, () => {
            this.generateRequestPayload();
        });
    }
    
    generateRequestPayload = () => {
        // console.log("[geoDatasetsPayload]", this.state.geoDatasetsPayload);
        // console.log("[profileDatasetsPayload]", this.state.profileDatasetsPayload);
        // console.log("[profileDatasetsBySites]", this.state.profileDatasetsBySites);
        // console.log("[geoDatasetsBySites]", this.state.geoDatasetsBySites);

        // prepare payload
        const payload = {
            userFirstName: this.state.contactInfo.firstName,
            userLastName: this.state.contactInfo.lastName,
            userEmail: this.state.contactInfo.email,
            userCompany: this.state.contactInfo.org,
            userComments: this.state.contactInfo.comments,
            userPhoneNumber: this.state.contactInfo.phoneNumber,
            geoDataIDs: this.state.geoDatasetsPayload,
            profileDataIDs: JSON.stringify(this.state.profileDatasetsPayload),
            profileDatasetPreview: JSON.stringify(this.state.profileDatasetsBySites),
            geoDatasetPreview: JSON.stringify(this.state.geoDatasetsBySites)
        }

        if (this.props.onPayloadReady) {
            this.props.onPayloadReady(payload);
        }
    }

    showError = (error) => {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    render() {
        return (
            <div className="request-container">

                <div className="request-container-header">
                    Review your selection and submit:
                </div>
                <RequestView
                    profileDatasetsBySites={this.state.profileDatasetsBySites}
                    geoDatasetsBySites={this.state.geoDatasetsBySites}
                ></RequestView>

                {/* <div className="request-view-footer"  >
                    <button onClick={this.submitRequest}><i className="fas fa-paper-plane"></i>Submit Request</button>
                </div> */}



            </div>
        )
    }
}

export default RequestPreview
